import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { notSupportDialogStyles } from "./styles";
import Dialog from "./Dialog";

let browserSuggestions = [
  {
    name: "Google Chrome",
    link: "https://www.google.com/chrome/",
    logo:
      "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:low/v1536540683/mondaybee/assets/chrome_logo.png"
  },
  {
    name: "Mozilla Firefox",
    link: "https://www.mozilla.org/en-US/firefox/",
    logo:
      "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:low/v1536540686/mondaybee/assets/firefox_logo.png"
  }
];

const platform = window.navigator.platform.toLowerCase();

if (platform.indexOf("win") !== -1) {
  browserSuggestions.push({
    name: "Microsoft Edge",
    link: "https://www.microsoft.com/en-hk/windows/microsoft-edge",
    logo:
      "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:low/v1536540683/mondaybee/assets/edge_logo.png"
  });
} else if (
  platform.indexOf("mac") !== -1 ||
  platform.indexOf("iphone") !== -1 ||
  platform.indexOf("ipad") !== -1
) {
  browserSuggestions.push({
    name: "Apple Safari",
    link: "https://support.apple.com/downloads/safari",
    logo:
      "https://res.cloudinary.com/nrator/image/upload/f_auto,q_auto:low/v1536540683/mondaybee/assets/safari_logo.png"
  });
}

const NotSupportDialog = withStyles(notSupportDialogStyles)(
  ({ classes, ...props }) => (
    <Dialog title="Sorry, your browser is not supported." {...props}>
      <div className={classes.content}>
        <p className={classes.description}>
          Please use one of following modern browsers. You'll see that Mondaybee
          and <i>many other websites</i> work better on them.
        </p>
        <div className={classes.browsersContainer}>
          {browserSuggestions.map((b, i) => (
            <a
              href={b.link}
              target="_blank"
              rel="noreferrer noopener nofollow"
              className={classNames(classes.browser)}
              style={{ width: 100 / browserSuggestions.length + "%" }}
              key={i}
            >
              <img className={classes.browserImg} src={b.logo} alt={b.name} />
              <p>{b.name}</p>
            </a>
          ))}
        </div>
      </div>
    </Dialog>
  )
);

export default NotSupportDialog;



// WEBPACK FOOTER //
// ./src/components/Dialogs/NotSupportDialog.js